import React, { useEffect, useState } from "react";
import BaseCard from "../../../components/ui/BaseCard";
import BaseEditor from "../../../components/ui/BaseEditor";
import BaseSwitch from "../../../components/ui/BaseSwitch";
import FieldLabel from "../../../components/ui/FieldLabel";
import { useDispatch, useSelector } from "react-redux";
import { updateWorkOrderForm } from "../../../store/workOrder/workOrderSlice";
const DescriptionForm = ({ isEditMode = false, workOrderData = {}, onHydrate }) => {
  const [isConfidential, setIsConfidential] = useState(false);
  const dispatch = useDispatch();
  const serviceDescription = useSelector(
    (state) => state.workOrder.summary.serviceDescription
  );
  useEffect(() => {
    if (isEditMode && workOrderData) {
      const data = workOrderData;
      const hydratedDescription = {
        description: data.serviceDescription || "",
        confidentialInformation: data.confidentialInformation || "",
      };

      dispatch(
        updateWorkOrderForm({
          step: "summary",
          data: { serviceDescription: hydratedDescription },
        })
      );
      // Baseline for the edit modal's Save Changes button — see useSectionChanges.
      onHydrate?.(hydratedDescription);

      if (data.confidentialInformation) {
        setIsConfidential(true);
      }
    }
  }, [isEditMode, workOrderData, dispatch]);

  const handleChange = (name, value) => {
    dispatch(
      updateWorkOrderForm({
        step: "summary",
        data: {
          serviceDescription: {
            ...serviceDescription,
            [name]: value,
          },
        },
      })
    );
  };
  return (
    <BaseCard className="py-4 lg:px-16 px-5 mt-2 rounded-lg" elevation={1}>
      <div className="border-bottom mb-4">
        <h6 className="mb-2 text-dark">Service Description</h6>
      </div>

      <div>
        <FieldLabel
          label="Work Description"
          requirement="optional"
          hint="(Provide precise instructions to guarantee your work order is completed correctly)"
        />
        <BaseEditor
          className="min-h-36"
          value={serviceDescription?.description || ""}
          onChange={(body) => handleChange("description", body)}
        />

        <div className="flex items-center mt-8 mb-3">
          <p className="font-normal mr-2 whitespace-nowrap">
            Confidential Information
            <span className="font-light italic ml-1">– Optional</span>
          </p>
          <BaseSwitch
            secondary={true}
            checked={isConfidential}
            onChange={() => setIsConfidential(!isConfidential)}
          />
          <p className="leading-normal ml-3 sm:block hidden ">
            (<span className="font-medium">Note:</span> Critical information
            will be confidential to you and will not display to providers)
          </p>
        </div>
        {isConfidential && (
          <div className="mb-4">
            <BaseEditor
              className="min-h-36"
              value={serviceDescription?.confidentialInformation || ""}
              onChange={(body) =>
                handleChange("confidentialInformation", body)
              }
            />
          </div>
        )}
      </div>
    </BaseCard>
  );
};

export default DescriptionForm;
